// Copyright (c) Move Closer 2022.

import { Injectable } from '@movecloser/front-core'

import { SESSION_COOKIE_KEY } from './session.helpers'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface ISessionService {
  sessionToken: string | null
  deleteAuthCookie (): void
  setAuthCookie (token: string): void
  setSessionToken (token: string | null): void
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Injectable()
export class SessionService implements ISessionService {
  public sessionToken: string | null = null

  public setAuthCookie (token: string) {
    document.cookie = `${SESSION_COOKIE_KEY}=${token};SameSite=None;Secure;path=/;`
    this.sessionToken = token
  }

  public deleteAuthCookie () {
    document.cookie = `${SESSION_COOKIE_KEY}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`
    this.sessionToken = null
  }

  public setSessionToken (token: string | null): void {
    this.sessionToken = token
  }
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const SessionServiceType = Symbol.for('ISessionService')
